import React, { useEffect, useMemo } from 'react';
import { Container, Breadcrumb, Row } from 'react-bootstrap';
import { useParams, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import Col from '../../../components/Col/Col';
import ScreenHeader from '../../../components/ScreenHeader/ScreenHeader';
import WebVideo from '../../../components/WebVideo/WebVideo';

import Styles from './Notification.module.scss'

import * as actions from '../../../store/actions';
import { LOCALE_NAMESPACE } from '../../../const/translations/LOCALE_NAMESPACE';
import { ROUTER_URL } from '../../../const/ROUTER_URL';
import { useFormatedText } from '../../../hooks/useFormattedText';

const REGEXP_INSTAGRAM_URL = /http(?:s?):\/\/(?:www\.)?instagram\.com(\/p\/)(\w+\/?)/

const SOCIAL_TYPE = {
    INSTAGRAM: 'instagram',
};

const Notification = () => {
    const { promotionId } = useParams();
    const dispatch = useDispatch();

    const { style, promotions } = useSelector(state => ({
        style: state.widget.style,
        promotions: state.companies.promotions
    }));

    const promotion = useMemo(() => (
        promotions.find(promotion => (
            promotion.id === parseInt(promotionId)
        ))
    ), [promotions, promotionId]);

    const {
        photo_url: photoURL,
        video_url: videoURL,
        name,
        description,
        services
    } = promotion ?? {}

    const { t } = useTranslation(LOCALE_NAMESPACE.COMMON);

    const preparedDescription = useFormatedText(description);


    useEffect(() => {
        if (!promotion) {
            dispatch(actions.getPromotions())
        }
    }, [promotion, dispatch])

    let type = null;
    if (videoURL && videoURL.match(REGEXP_INSTAGRAM_URL)) {
        type = SOCIAL_TYPE.INSTAGRAM
    }

    const descriptionClassName = useMemo(() => (
        type === SOCIAL_TYPE.INSTAGRAM 
        && style !== 'side'
            ? 'p-0 pl-md-4' 
            : 'p-0'
    ), [type, style])

    if (!promotion) {
        return null
    }

    return (
        <>
            <ScreenHeader>
                <Breadcrumb>
                    <Breadcrumb.Item>
                        <Link to={ROUTER_URL.NOTIFICATIONS} data-testid='data-test-notificationsScreen-title'>
                            {t('notificationsScreen.header')}
                        </Link>
                    </Breadcrumb.Item>

                    <Breadcrumb.Item active>
                        {name}
                    </Breadcrumb.Item>
                </Breadcrumb>
            </ScreenHeader>

            <Container className='d-flex pt-4 flex-column flex-grow-1 overflow-auto'>
                <Row className='px-3'>
                    <Col
                        xs={12} 
                        md={type !== SOCIAL_TYPE.INSTAGRAM ? 12 : 6}
                        className='p-0'
                    >   
                        {videoURL ? 
                            <WebVideo 
                                url={videoURL} 
                                className='w-100'
                            /> 
                            : <img
                                src={photoURL} 
                                alt={name}
                                className='w-100'
                            />
                        }
                    </Col>

                    <Col 
                        xs={12}
                        md={type !== SOCIAL_TYPE.INSTAGRAM ? 12 : 6}
                        className={descriptionClassName} 
                    >
                        <p className={Styles.description}>
                            {preparedDescription}
                        </p>

                        <div className='border-muted border-bottom'/>

                        {services.length !== 0 && (
                            <>
                                <p className='mt-4 font-size-14 text-muted text-uppercase font-weight-black'>
                                    {t('notificationScreen.promotionIncludeServices')}
                                </p>

                                <ul 
                                    style={{ listStyleType: 'none' }}
                                    className='list-style-type-none pb-4 pl-0'
                                >
                                    {services.map(({ name }) => (
                                        <li
                                            key={`${name}-key`}
                                            className='pb-2'
                                        >
                                            {name}
                                        </li>
                                    ))}
                                </ul>
                            </>
                        )}
                    </Col>
                </Row>
            </Container>
        </>
    )
};

export default Notification
